import React, { useState } from "react";

import { toast } from "react-hot-toast";
import { Input, Select, TextArea } from "components/Form";
import { Button } from "components/Button/Button";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import { getCenters, getCourseVertical } from "services/master";
import { addCenter } from "services/centers";
import ModalBox from "components/modal/ModalBox";
import { addMasterState, cityWiseCenterCreate, dropdownMasterStates } from "services/citypages";

const AddCenterWiseCity = ({ open, onClose, citywisecenterListing }) => {
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [allStates, setAllStates] = useState([]);
    const [allVerticals, setAllVerticals] = useState([]);

    const [centerWiseData, setCenterData] = useState({
        mstateid: "",
        city: "",
        news: "",
    });

    const [errorField, setErrorField] = useState({
        mstateid: "",
        city: "",
    });

    //*********************Handel Validation********************************** */
    const handleValidation = () => {
        let errorField = {};
        let formIsValid = true;

        if (!centerWiseData.mstateid) {
            errorField["mstateid"] = "Please Select State";
            formIsValid = false;
        }
        if (!centerWiseData.city) {
            errorField["city"] = "Please Enter City";
            formIsValid = false;
        }


        setErrorField(errorField);
        return formIsValid;
    };

    //*********************Submit Center Handler********************************** */
    const submitCenterHandler = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setSubmitLoading(true);
            try {
                const finalData = {
                    mstateid: centerWiseData.mstateid,
                    city: centerWiseData.city,
                    news: centerWiseData.news,
                };
                const res = await cityWiseCenterCreate(finalData);

                if (res.code === 200) {
                    toast.success(res.message);
                    setSubmitLoading(false);
                    citywisecenterListing();
                    modalOnClose();
                } else {
                    toast.error(res.message);
                    setSubmitLoading(false);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
                setSubmitLoading(false);
            }

        } else {
            toast.error("Please fill all the fields");
        }
    };

    //   onChange Handler
    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        if (name === "latitude" || name === "longitude") {
            setCenterData({ ...centerWiseData, [name]: value.replace(/[^0-9.]/g, "") });
        } else {
            setCenterData({ ...centerWiseData, [name]: value });
        }
    };

    // this function is used for clear data on close
    const modalOnClose = () => {
        setCenterData({
            centerId: "",
            verticalId: "",
            latitude: "",
            longitude: "",
        });
        onClose();
    };

    // --------------- getting all required masters data ----------------//
    React.useLayoutEffect(() => {
        const getStatesListing = async () => {
            try {
                const res = await dropdownMasterStates();
                if (res.code === 200) {
                    setAllStates(res.data.masterstates || []);
                } else {
                    toast.error(res.message);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
            }
        };

        const getVerticalData = async () => {
            try {
                const res = await getCourseVertical();
                if (res.code === 200) {
                    setAllVerticals(res.data.courseVerticles.rows || []);
                } else {
                    toast.error(res.message);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
            }
        };

        // calls all the master functions
        getStatesListing();
        getVerticalData();

        // eslint-disable-next-line
    }, []);

    return (
        <>
            <ModalBox
                status={open}
                onClose={modalOnClose}
                size="sm"
                title={"Add New City"}
                customizedFooter={
                    <div>
                        <Button onClick={submitCenterHandler} {...submitButtonElement}>
                            Add City
                        </Button>
                    </div>
                }
            >
                <div className="form-group row mt-1">
                    <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                        <div className="row">
                            <div className="col-sm-12 col-form-label">
                                <Input
                                    type="text"
                                    name="city"
                                    value={centerWiseData.city}
                                    onChange={onChangeHandler}
                                    placeholder="Enter City"
                                    className={`form-control `}
                                    label={"City"}
                                    error={errorField.city}
                                    required
                                    {...submitButtonElement}
                                />
                            </div>
                            <div className="col-sm-12 col-form-label">
                                <Select
                                    name="mstateid"
                                    placeholder="Select State"
                                    onChange={onChangeHandler}
                                    value={centerWiseData.mstateid}
                                    className={`form-control `}
                                    label={"State"}
                                    error={errorField.mstateid}
                                    required
                                    {...submitButtonElement}
                                >
                                    <option value="">Select State</option>
                                    {allStates &&
                                        allStates.map(({ id, statename }) => {
                                            return (
                                                <option value={id} key={id}>
                                                    {statename}
                                                </option>
                                            );
                                        })}
                                </Select>
                            </div>
                            {/* <div className="col-sm-12 col-form-label">
                                <TextArea
                                    type="text"
                                    name="news"
                                    value={centerWiseData.news}
                                    onChange={onChangeHandler}
                                    placeholder="Enter news"
                                    className={`form-control `}
                                    label={"News"}
                                    {...submitButtonElement}
                                    rows={2}
                                />
                            </div> */}
                            


                        </div>
                    </div>
                </div>
            </ModalBox>
        </>
    );
};

export default AddCenterWiseCity;
